import { type ReactElement } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  PeopleIcon,
} from "@citibox-panel/ui";

export function TableDemo(): ReactElement {
  return (
    <Table aria-label="Entregas de ejemplo">
      <TableHead>
        <TableRow>
          <TableCell component="th" scope="col" />
          <TableCell component="th" scope="col">
            ENTREGA
          </TableCell>
          <TableCell component="th" scope="col">
            ESTADO
          </TableCell>
          <TableCell component="th" scope="col">
            BUZÓN
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow selected onClick={() => undefined}>
          <TableCell />
          <TableCell>03/06/2026</TableCell>
          <TableCell>
            <Chip label="Stored" color="info" />
          </TableCell>
          <TableCell>DIZ03</TableCell>
        </TableRow>
        <TableRow onClick={() => undefined}>
          <TableCell>
            <PeopleIcon fontSize="small" aria-label="Compartida con este usuario" />
          </TableCell>
          <TableCell>04/05/2026</TableCell>
          <TableCell>
            <Chip label="Expired" color="warning" />
          </TableCell>
          <TableCell>DIZ05</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}
